import homeSvg from '@/assets/font-svg/home.svg'
import homeHoverSvg from '@/assets/font-svg/home_hover.svg'

const dashbroad = () => import('@/views/Home/dashbroad')
const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏 icon 图片名,
    activeIcon: 'svg-name'       侧栏鼠标 hover 或者 active 时的 icon 图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不 keep-alive
  }
**/

export default [
  {
    path: '/dashbroad',
    name: 'dashbroad',
    component: Home,
    redirect: '/dashbroad/index',
    title: '首页',
    meta: {
      title: '首页',
      icon: homeSvg,
      activeIcon: homeHoverSvg,
      sort: 1,
      showSubiems: false,
      modules: 'home',
      permission: '',
    },
    children: [
      {
        path: 'index',
        name: 'index',
        component: dashbroad,
        meta: {
          title: '仪表盘',
          active: ['dashbroad'],
          permission: '',
        },
      },
    ],
  },
]
